import Cookies from "js-cookie"

const removeCookieFromCurrentDomain = (cookieName: string, requestUrl: string): void => {
    const domain = requestUrl ? new URL(requestUrl).hostname : window?.location?.hostname
    Cookies.remove(cookieName, {path: "/", domain})
}

export {removeCookieFromCurrentDomain}
